var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadArrow = function SvgDownloadArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    overflow: "visible",
    width: "75pt",
    height: "75pt",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "black",
    fontFamily: "Times New Roman",
    fontSize: 16,
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0 -75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.255,0.376 L 6.255,7.421 L 68.745,7.421 L 68.745,0.376 L 6.255,0.376 Z M 37.41,8.688 L 12.298,46.988 L 27.105,46.988 L 27.105,74.625 L 47.878,74.625 L 47.878,46.988 L 62.697,46.988 L 37.41,8.688 Z",
    fill: "#ffffff",
    stroke: "none",
    strokeWidth: 0.5,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DownloadArrow.d3b5a501.svg";
export { ForwardRef as ReactComponent };